import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { CustomerModel } from 'app/account-settings/models/customer.model';
import { CurrentContextService } from 'app/core/current-context.service';

/**
 * Whether the native app product is unlocked: "App Experiences" in the navigation, the allowed
 * native apps setting and the Public API setting. Set per customer in the backoffice; there is no
 * admin override, so an admin previewing it has to turn it on for the customer.
 */
export function isAppExperiencesEnabled(customer: CustomerModel | null | undefined): boolean {
  return customer?.enableAppExperiences === true;
}

@Injectable({ providedIn: 'root' })
export class AppExperiencesService {
  private readonly currentContextService = inject(CurrentContextService);

  private readonly customer = toSignal(
    this.currentContextService.currentContextBS.pipe(map((context) => context?.customer)),
    { initialValue: null as CustomerModel | null },
  );

  public readonly enabled: Signal<boolean> = computed(() => isAppExperiencesEnabled(this.customer()));
}
